module.exports = __webpack_public_path__ + "static/home_blue@3x-0577fe789e01e12dbe5d0f82d0cbad2d.png";